import React from 'react';
import PropTypes from 'prop-types';
import PlaceholderLetterSvg from '../../assets/svg/icons/placeholder-letter.svg';
import { StyledIcon } from './styles';

const RoundIcon = ({ children, color }) => (
  <StyledIcon color={color}>{children || <PlaceholderLetterSvg />}</StyledIcon>
);

RoundIcon.propTypes = {
  color: PropTypes.oneOf([
    'gray',
    'purple',
    'orange',
    'pink',
    'teal',
    'green',
    'turquoise',
    'yellow',
    'violet',
  ]),
};

RoundIcon.defaultProps = {
  color: 'gray',
};

export default RoundIcon;
